import snsAxiosClient from '../common/http/http-sns';
import { get, toPairs, reduce } from 'lodash';

export type AvailableSlotsPayload = {
  orderId: number;
  uuid: string;
};

function getAllAvailableSlotsInfo(environmentVariables, user, payload: AvailableSlotsPayload) {
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_GET_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };

  const queryParams = {
    orderId: get(payload, 'orderId'),
    uuid: get(payload, 'uuid'),
  };

  const queryParamsString = reduce(
    toPairs(queryParams),
    (query, [key, value], i) => {
      return `${query}${!!i ? '&' : ''}${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
    },
    '',
  );

  return snsAxiosClient(options).get(
    `${get(environmentVariables, 'GET_ALL_AVAILABLE_SLOTS_INFO', 'get_available_slots')}?${queryParamsString}`,
  );
}

export default getAllAvailableSlotsInfo;
